var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84655 1H15.3914C15.6159 1 15.8312 1.08919 15.99 1.24795C16.1487 1.40671 16.2379 1.62203 16.2379 1.84655V3.18918C16.2379 3.41368 16.1486 3.62897 15.9899 3.78769L10.5592 9.21746C10.4008 9.37632 10.3119 9.59159 10.3121 9.81597V15.1535C10.312 15.2822 10.2827 15.4091 10.2263 15.5248C10.1698 15.6404 10.0878 15.7417 9.98631 15.8208C9.88486 15.9 9.76671 15.955 9.64081 15.9816C9.51492 16.0083 9.38461 16.0059 9.25979 15.9746L7.56669 15.5514C7.38363 15.5055 7.22114 15.3998 7.10503 15.251C6.98892 15.1022 6.92586 14.9189 6.92585 14.7302V9.81597C6.9258 9.59147 6.83658 9.37618 6.67781 9.21746L1.24719 3.78769C1.08873 3.62883 0.999824 3.41356 1 3.18918V1.84655C1 1.62203 1.08919 1.40671 1.24795 1.24795C1.40671 1.08919 1.62203 1 1.84655 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e340b6f5571de6db22fa23cf63a7bb43.svg";
export { ForwardRef as ReactComponent };